<template>
  <footer class="search-footer">
    <span>
      Jesteś dealerem?
      <a href="https://infopanel.cloud/" target="_blank" rel="noopener"
        >Dowiedz się więcej</a
      >
    </span>
  </footer>
</template>

<script>
export default {
  name: "SearchFooter",
};
</script>
